import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { LocalStorageService } from '../storage/localstorage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authService: AuthService,
    private localstorage: LocalStorageService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = localStorage.getItem('access_token_ikena');

    let authReq = req;
    if (token) {
      authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const userStorage = this.localstorage.getUsers()?.data;
          if (!userStorage || !userStorage.reference) {
            this.handleLogout();
            return throwError(error);
          }
        }
        return throwError(error);
      })
    );
  }

  
  private handleLogout() {
    localStorage.removeItem('access_token_ikena');
    this.router.navigate(['/']);
  }
}
